"use client";

import { useEffect, useState } from "react";
import Script from "next/script";

export function GAHeaders() {
  const GA_TAG = "G-5HG4KE4CH0";
  const enableAnalytics = process.env.NODE_ENV == "production";
  return (
    <>
      {enableAnalytics && (
        <script
          dangerouslySetInnerHTML={{
            __html: `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              const EU = [
                'AL', 'AD', 'AT', 'AZ', 'BY',
                'BE', 'BA', 'BG', 'HR', 'CY',
                'CZ', 'DK', 'EE', 'FI', 'FR',
                'GE', 'DE', 'GR', 'HU', 'IS',
                'IE', 'IT', 'KZ', 'XK', 'LV',
                'LI', 'LT', 'LU', 'MK', 'MT',
                'MD', 'MC', 'ME', 'NL', 'NO',
                'PL', 'PT', 'RO', 'RU', 'SM',
                'RS', 'SK', 'SI', 'ES', 'SE',
                'CH', 'TR', 'UA', 'GB', 'VA',
              ];

              gtag('set', 'url_passthrough', true);
              gtag('consent', 'default', {
                'ad_storage': 'denied',
                'ad_user_data': 'denied',
                'ad_personalization': 'denied',
                'analytics_storage': 'denied',
                'region': EU,
              });
              gtag('js', new Date());
              gtag('config', '${GA_TAG}');
            `,
          }}
        />
      )}
      {enableAnalytics && (
        <script async src={`https://www.googletagmanager.com/gtag/js?id=${GA_TAG}`}/>
      )}
    </>
  );
}

export function GAScript() {
  const enableAnalytics = process.env.NODE_ENV == "production";
  const [consent, setConsent] = useState<boolean>(false);

  useEffect(() => {
    const consentCookie = localStorage.getItem("cookie-consent");
    setConsent(consentCookie === "accepted");
  }, []);

  return (
    <>
      {enableAnalytics && consent === true && (
        <Script
          id="consupd"
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{
            __html: `
            gtag('consent', 'update', {
              'ad_storage': 'granted',
              'analytics_storage': 'granted'
              'ad_user_data': 'granted',
              'ad_personalization': 'granted',
            });
          `,
          }}
        />
      )}
    </>
  );
}
